import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { PasswordInput } from "@/components/shared/PasswordInput";
import { Label } from "@/components/ui/label";
import { PasswordStrength } from "@/components/PasswordStrength";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { applyAuth } = useAuth();
  const nav = useNavigate();
  const mismatch = confirm.length > 0 && confirm !== password;

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Hesla se neshodují."); return; }
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/accept-invite", { token, password });
      applyAuth(data);
      nav("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Přijmout pozvánku" subtitle="Nastavte si heslo a připojte se k týmu">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="password">Heslo</Label>
          <PasswordInput id="password" data-testid="invite-password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 mt-1.5" minLength={10} required />
          <PasswordStrength password={password} />
        </div>
        <div>
          <Label htmlFor="password2">Heslo znovu</Label>
          <PasswordInput id="password2" data-testid="invite-password2" value={confirm} onChange={(e) => setConfirm(e.target.value)}
            className={`h-12 mt-1.5 ${mismatch ? "border-destructive focus-visible:ring-destructive" : ""}`} minLength={10} required />
          {mismatch && <p data-testid="invite-password-mismatch" className="text-destructive text-xs mt-1">Hesla se neshodují.</p>}
        </div>
        {error && <div data-testid="invite-error" className="text-destructive text-sm">{error}</div>}
        <Button type="submit" disabled={loading} data-testid="invite-submit" className="w-full h-12 font-bold">
          {loading ? "Přihlašuji…" : "Připojit se k týmu"}
        </Button>
      </form>
    </AuthShell>
  );
}
